import { render, staticRenderFns } from "./GravitacaoNewtonEq.vue?vue&type=template&id=4c82be71&scoped=true&"
import script from "./GravitacaoNewtonEq.vue?vue&type=script&lang=js&"
export * from "./GravitacaoNewtonEq.vue?vue&type=script&lang=js&"
import style0 from "./GravitacaoNewtonEq.vue?vue&type=style&index=0&id=4c82be71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c82be71",
  null
  
)

export default component.exports